export const SET_ROLES = 'SET_ROLES'
export const RESET_ROLES = 'RESET_ROLES'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const RESET_CATEGORIES = 'RESET_CATEGORIES'
export const SET_GROUPS = 'SET_GROUPS'
export const RESET_GROUPS = 'RESET_GROUPS'
